import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import aldo from "../../Assets/Projects/aldo.png";
import diggs from "../../Assets/Projects/diggs.png";
import proven from "../../Assets/Projects/proven.png";
import vacationrenter from "../../Assets/Projects/vacationrenter.png";
import enfety from "../../Assets/Projects/enfety.png";
import kickfin from "../../Assets/Projects/kickfin.png";
import earthfund from "../../Assets/Projects/earthfund.png";
import ethsign from "../../Assets/Projects/ethsign.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ethsign}
              isBlog={false}
              title="React, Redux, GraphQL, Web3, etherjs, ethereum, TypeScript"
              description="I have worked as a senior full-stack developer and a tech-lead at this project. Our team has built a brand-new crytocurrency-based document sign platform."
              link="https://www.ethsign.xyz/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={earthfund}
              isBlog={false}
              title="React, Next.js, Node.js, DAO, Web3"
              description="As a senior front-end developer, I have focused on UI implementation for this platform. I have collaborated with UI/UX designers and Product Design team and have built an awesome project."
              link="https://www.earthfund.io/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vacationrenter}
              isBlog={false}
              title="React, Next.js, Node.js, MongoDB"
              description="I worked as a senior full-stack web developer to maintain this app. I refactored the front-end codebase with new tech stuff. Upgraded React Class Components to functional components with React hook. Improved code quality for all existing and new Components build close to over 95% with an emphasis on TDD."
              link="https://www.vacationrenter.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aldo}
              isBlog={false}
              title="React, Node.js, Express"
              description="A brand new React and Express.js responsive eCommerce web app that transforms shoppers online experence. One of the fun parts of this project is that I designed an algorithm for the dynamic grid display system for better user browsing experience. Check it out; it looks really cool."
              link="https://www.aldoshoes.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={proven}
              isBlog={false}
              title="React, Redux, Node.js, MongoDB"
              description="A platform that uses AI to personalize your skincare based on lifestyle and skin type.
              Built a web app for Provenskincare with React, Redux, Redux-thunk, Hapi.js, Node.js, MongoDB, and Stripe
              I was a full-stack developer who led a team of three developers."
              link="https://www.provenskincare.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={enfety}
              isBlog={false}
              title="React, Express, Node.js"
              description="Entefy is an AI-enabled, multi-format, multi-channel communication platform which integrates with all major forms of digital communication and seamlessly syncs them across all your digital devices.
              Entefy is designed platform-first with the entire server and infrastructure stack custom designed for performance and scalability for millions of users."
              link="http://entefy.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kickfin}
              isBlog={false}
              title="React, Redux, Node.js, PostgreSQL"
              description="Kickfin® provides closed-loop cash management by leveraging technology to deliver managed cash services, real-time analytics, and actionable insights into the worksite & total organization cash operations. By optimizing cash management through our cloud-based software, we have the ability to materially reduce cash acceptance and management."
              link="http://www.kickfin.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={diggs}
              isBlog={false}
              title="React, Gatsby, Styled-Components"
              description="Developed a dynamic and interactive website that ensured high traffic, page views, and user experience.
              Used SEO best practices to elevate an organization’s web presence; achieved top 10 Google rankings on several highly competitive keywords."
              link="https://www.diggs.pet/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
